import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect } from "react";
import { Calendar as BigCalendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "moment/locale/es";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./styles.css";
import { EventAgendaProjects } from "./EventAgendaComponents";
import { useState } from "react";
var messagesDefault = {
  date: "Date",
  time: "Time",
  event: "Event",
  allDay: "All Day",
  week: "Week",
  work_week: "Work Week",
  day: "Day",
  month: "Month",
  previous: "Back",
  next: "Next",
  yesterday: "Yesterday",
  tomorrow: "Tomorrow",
  today: "Today",
  agenda: "Agenda",
  noEventsInRange: "There are no events in this range.",
  showMore: function showMore(e) {
    return "+" + e + " more";
  }
};
var localizer = momentLocalizer(moment);

var Calendar = function Calendar(props) {
  var variant = props.variant,
      events = props.events;

  var _useState = useState(moment()),
      _useState2 = _slicedToArray(_useState, 2),
      date = _useState2[0],
      setDate = _useState2[1];

  useEffect(function () {
    props.date ? setDate(props.date) : setDate(moment());
  }, [props.date]);
  var componentAgenda = null;

  if (!componentAgenda) {
    // console.log("rendering variant calendar");
    switch (variant) {
      case "projects":
        componentAgenda = function componentAgenda(event) {
          return /*#__PURE__*/React.createElement(EventAgendaProjects, {
            onClickEventAgenda: props.onClickEventAgenda,
            event: event
          });
        };

        break;

      default:
        // console.log("Not supported variant", props.variant);
        break;
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: "80vh"
    }
  }, /*#__PURE__*/React.createElement(BigCalendar, {
    localizer: localizer,
    culture: "es",
    events: events,
    startAccessor: "start",
    endAccessor: "end",
    date: date,
    onNavigate: function onNavigate(_date) {
      return setDate(_date);
    },
    defaultView: props.defaultView || Views.WEEK,
    onSelectEvent: props.onSelectEvent,
    components: {
      agenda: {
        event: componentAgenda
      }
    },
    messages: props.messages || messagesDefault
  }));
};

export { Calendar };